import { render, staticRenderFns } from "./AiringCalendar.vue?vue&type=template&id=0b3c2ae1&scoped=true"
import script from "./AiringCalendar.vue?vue&type=script&lang=js"
export * from "./AiringCalendar.vue?vue&type=script&lang=js"
import style0 from "./AiringCalendar.vue?vue&type=style&index=0&id=0b3c2ae1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3c2ae1",
  null
  
)

export default component.exports